export const PHONE_DISPLAY = "(510) 328-8368";
export const PHONE_TEL = "+15103288368";
export const GOOGLE_PROFILE_URL = "https://share.google/jiN5rfDseQWhzMXmY";

export const images = {
  logo: "/images/marvin/marvin-plumbing-logo.svg",
  ownerPortrait: "/images/marvin/owner-portrait.png",
  heroJob: "/images/marvin/water-heater-after.png",
  waterHeaterBefore: "/images/marvin/water-heater-before.png",
  waterHeaterAfter: "/images/marvin/water-heater-after.png",
  gasMeterBefore: "/images/marvin/gas-meter-before.png",
  gasMeterAfter: "/images/marvin/gas-meter-after.png",
};

export const content = {
  en: {
    langLabel: "English",
    nav: { services: "Services", pricing: "Pricing", gallery: "Gallery", estimate: "Free Estimate" },
    header: { call: `Call ${PHONE_DISPLAY}`, shortCall: "Call", emergency: "24/7 Emergency" },
    hero: {
      eyebrow: "Oakland • East Bay • Se habla español",
      title: "Oakland’s trusted plumber for 20+ years.",
      subtitle:
        "Free estimates, upfront pricing, and fast emergency help for homes and businesses across the East Bay.",
      call: `Call Now ${PHONE_DISPLAY}`,
      estimate: "Get a Free Estimate",
      rating: "★★★★★ 4.8 · 23 reviews",
      spanishCue: "Se habla español",
      imageAlt: "Marvin Mendoza smiling during a customer consultation",
    },
    trust: ["20+ Years", "Family-Owned", "Free Estimates", "24/7 Emergency", "Residential & Commercial", "Se Habla Español"],
    servicesIntro: {
      label: "What we fix",
      title: "One visit. Clear quote. Done right.",
      text: "From urgent leaks to remodels and commercial jobs, Marvin Plumbing handles the problems that stop your day.",
    },
    signsLabel: "Signs you need this:",
    services: [
      { title: "Water Heater Repair & Installation", text: "Tank and tankless service to restore hot water quickly and safely.", signs: ["Pooling water", "Strange noises", "Rusty water", "Unit over 15 years old"] },
      { title: "Drain Cleaning & Repair", text: "Camera-snake diagnosis, sewer repair, and pipe repair for stubborn clogs.", signs: ["Slow drains", "Tree-root intrusion", "Leaky joints", "Blocked or corroded lines"] },
      { title: "Leak Detection & Repair", text: "Find hidden leaks before they damage walls, floors, or cabinets.", signs: ["Rising water bill", "Stained walls or paint", "Damaged flooring", "Mold or mildew"] },
      { title: "Toilet & Bathroom Plumbing", text: "Faucets, showers, toilet repair, bathroom fixes, and re-piping.", signs: ["Running toilet", "Weak flush", "Dripping faucet", "Low shower pressure"] },
      { title: "General Plumbing Repair", text: "Burst pipes, leaky faucets, sump pumps, water, sewer, and gas lines.", signs: ["Active leak", "Noisy pipes", "Sewer smell", "Multiple issues at once"] },
      { title: "Repiping & Pipe Installation", text: "Clean pipe replacements and new pipe runs built for long-term reliability.", signs: ["Old pipes", "Poor pressure", "Frequent leaks", "Remodeling work"] },
      { title: "Backflow Prevention", text: "Protect clean water systems for homes, businesses, and public spaces.", signs: ["Inspection coming", "Commercial need", "Water safety concern"] },
      { title: "New Construction & ADU Plumbing", text: "Subcontract plumbing and gas work built to pass inspection.", signs: ["ADU build", "New addition", "Kitchen or bath buildout", "Gas inspection"] },
      { title: "Gas Line Services", text: "Emergency gas line response available 24/7 for urgent safety concerns.", signs: ["Gas smell", "Appliance install", "Line damage", "Emergency shutoff"] },
      { title: "Commercial Plumbing", text: "Restaurants, hotels, offices, clinics, assisted living, retail, schools, and public buildings.", signs: ["Downtime risk", "Code needs", "Fixture issues", "Preventive repair"] },
    ],
    pricing: {
      label: "Clear quotes",
      title: "Free estimates. Upfront quote before work starts.",
      text: "No surprise numbers on the website — Marvin looks at the job, explains the options, and gives you a clear quote before any work begins.",
      items: [
        ["Quote Consultation", "Free estimate"],
        ["Water Heater Services", "Get quote"],
        ["Drain Services", "Get quote"],
        ["Plumbing Repairs", "Get quote"],
        ["Toilet & Bathroom Plumbing", "Get quote"],
        ["Emergency Plumbing", "Call now"],
      ],
    },
    about: {
      label: "About Marvin",
      title: "A real local plumber who treats customers like family.",
      text: "Marvin Mendoza brings 20+ years of hands-on plumbing experience to every call. Marvin Plumbing is family-owned and operated, serving residential and commercial customers with honest upfront pricing, steady communication, and a commitment to fixing the issue right the first time.",
      imageAlt: "Marvin Mendoza smiling during a customer consultation",
      points: ["Constant communication until the job is done", "Handles multiple issues in one visit", "Upfront quote before work starts"],
      promiseTitle: "Marvin Plumbing Promise",
      promiseText: "Clear communication, upfront pricing, and careful work from the first call to the final cleanup.",
      yearsLabel: "Years",
      emergencyLabel: "Emergency",
    },
    gallery: {
      label: "Visual proof",
      title: "See the Difference",
      text: "Real project photos from Marvin Plumbing. Before/after images are displayed fully — no cropping, zooming, or text overlays.",
      jobs: [
        { title: "Water heater replacement", before: "waterHeaterBefore", after: "waterHeaterAfter", alt: "Before and after water heater replacement by Marvin Plumbing" },
        { title: "Gas line safety upgrade", before: "gasMeterBefore", after: "gasMeterAfter", alt: "Before and after gas meter and gas line service by Marvin Plumbing" },
      ],
    },
    reviews: {
      label: "Customer trust",
      title: "★★★★★ 4.8 on Google",
      text: "Real words from homeowners and property owners who called Marvin Plumbing for leaks, water heaters, pressure issues, and urgent repairs.",
      link: "View Google Business Profile",
      cards: [
        { name: "Zoe Franklin", text: "I recently used Marvin Plumbing to repair a leak under my kitchen sink and was very pleased with the service. The technician arrived on time, explained the issue clearly, and completed the repair efficiently. Everything has been working perfectly since then. I would definitely use them again." },
        { name: "Roman Bradford", text: "Marvin Plumbing recently repaired a leaking pipe in our laundry room. The technician worked carefully, kept the area clean, and made sure everything was functioning properly before leaving. The whole process was smooth and stress-free." },
        { name: "Colton Bradford", text: "Really good experience with Marvin Plumbing. We had low water pressure in two bathrooms and they found the problem much faster than expected. The technician was polite, worked carefully, and made sure everything was running properly before leaving." },
        { name: "Sullivan Wilder", text: "Marvin Plumbing helped us with a water heater problem that needed quick attention. The plumber was professional, knowledgeable, and took the time to answer all of our questions. The repair was completed the same day and the price was reasonable." },
      ],
    },
    area: {
      label: "Service area",
      title: "Serving Oakland and the East Bay.",
      text: "Based in Oakland, Marvin Plumbing helps homeowners and businesses throughout the East Bay with fast, reliable plumbing support.",
      cities: ["Oakland", "Berkeley", "Alameda", "Emeryville", "San Leandro", "Piedmont", "Surrounding East Bay areas"],
    },
    form: {
      label: "Get help today",
      title: "Get a Free Estimate",
      text: "Tell us what is happening. Your request is saved reliably so Marvin can follow up.",
      name: "Name",
      namePlaceholder: "Your name",
      phone: "Phone",
      phonePlaceholder: "Best number to call",
      address: "Address or ZIP",
      addressPlaceholder: "Oakland, 946__",
      problem: "Problem description",
      problemPlaceholder: "Tell us about the leak, clog, heater, gas line, or plumbing issue",
      submit: "Request Free Estimate",
      submitting: "Sending request...",
      success: "Estimate request received. Marvin Plumbing will follow up soon.",
      error: "Please complete every field before sending.",
      callHelp: "Need urgent help? Call now:",
    },
    footer: {
      areaTitle: "Service Area",
      hours: "Hours: 7:00 AM–6:00 PM daily · 24/7 emergency service",
      area: "Oakland, Berkeley, Alameda, Emeryville, San Leandro, Piedmont, and surrounding East Bay areas",
    },
  },
  es: {
    langLabel: "Español",
    nav: { services: "Servicios", pricing: "Precios", gallery: "Galería", estimate: "Presupuesto Gratis" },
    header: { call: `Llamar ${PHONE_DISPLAY}`, shortCall: "Llamar", emergency: "Emergencias 24/7" },
    hero: {
      eyebrow: "Oakland • East Bay • Se habla español",
      title: "Su plomero de confianza en Oakland por más de 20 años.",
      subtitle:
        "Presupuestos gratis, precios claros y ayuda rápida para emergencias en casas y negocios del East Bay.",
      call: `Llame Ahora ${PHONE_DISPLAY}`,
      estimate: "Pedir Presupuesto Gratis",
      rating: "★★★★★ 4.8 · 23 reseñas",
      spanishCue: "Se habla español",
      imageAlt: "Marvin Mendoza sonriendo durante una consulta con un cliente",
    },
    trust: ["20+ Años", "Negocio Familiar", "Presupuestos Gratis", "Emergencias 24/7", "Residencial y Comercial", "Se Habla Español"],
    servicesIntro: {
      label: "Lo que reparamos",
      title: "Una visita. Precio claro. Trabajo bien hecho.",
      text: "Desde fugas urgentes hasta remodelaciones y trabajos comerciales, Marvin Plumbing resuelve los problemas que paran su día.",
    },
    signsLabel: "Señales de que lo necesita:",
    services: [
      { title: "Reparación e Instalación de Calentadores de Agua", text: "Servicio para calentadores de tanque y sin tanque para recuperar el agua caliente rápido y con seguridad.", signs: ["Agua acumulada", "Ruidos extraños", "Agua oxidada", "Unidad de más de 15 años"] },
      { title: "Limpieza y Reparación de Drenajes", text: "Diagnóstico con cámara/snake, reparación de drenaje principal y tubería para tapones difíciles.", signs: ["Drenajes lentos", "Raíces en la línea", "Uniones con fuga", "Tuberías tapadas o corroídas"] },
      { title: "Detección y Reparación de Fugas", text: "Encontramos fugas escondidas antes de que dañen paredes, pisos o gabinetes.", signs: ["Recibo de agua subiendo", "Manchas en paredes o pintura", "Piso dañado", "Moho o humedad"] },
      { title: "Plomería de Baños e Inodoros", text: "Llaves, regaderas, reparación de inodoros, arreglos de baño y re-piping.", signs: ["Inodoro corriendo", "Descarga débil", "Llave goteando", "Baja presión en la regadera"] },
      { title: "Reparación General de Plomería", text: "Tuberías rotas, llaves con fuga, bombas de sumidero, líneas de agua, drenaje y gas.", signs: ["Fuga activa", "Tuberías con ruido", "Olor a drenaje", "Varios problemas a la vez"] },
      { title: "Re-piping e Instalación de Tubería", text: "Reemplazos limpios e instalación de tubería nueva para durar por años.", signs: ["Tubería vieja", "Baja presión", "Fugas frecuentes", "Trabajo de remodelación"] },
      { title: "Prevención de Reflujo", text: "Protección para sistemas de agua limpia en casas, negocios y espacios públicos.", signs: ["Inspección próxima", "Necesidad comercial", "Preocupación por seguridad del agua"] },
      { title: "Plomería para Construcción Nueva y ADU", text: "Trabajo de subcontrato para plomería y gas hecho para pasar inspección.", signs: ["Construcción de ADU", "Nueva ampliación", "Cocina o baño nuevo", "Inspección de gas"] },
      { title: "Servicios de Línea de Gas", text: "Respuesta de emergencia 24/7 para líneas de gas y situaciones urgentes de seguridad.", signs: ["Olor a gas", "Instalación de aparato", "Daño en la línea", "Cierre de emergencia"] },
      { title: "Plomería Comercial", text: "Restaurantes, hoteles, oficinas, clínicas, casas asistidas, tiendas, escuelas y edificios públicos.", signs: ["Riesgo de cierre", "Requisitos de código", "Problemas con accesorios", "Reparación preventiva"] },
    ],
    pricing: {
      label: "Presupuestos claros",
      title: "Presupuestos gratis. Cotización antes de empezar.",
      text: "Sin números sorpresa en la página — Marvin revisa el trabajo, explica las opciones y le da una cotización clara antes de comenzar.",
      items: [["Consulta de Presupuesto", "Gratis"], ["Servicios de Calentador de Agua", "Pedir cotización"], ["Servicios de Drenaje", "Pedir cotización"], ["Reparaciones de Plomería", "Pedir cotización"], ["Plomería de Inodoro y Baño", "Pedir cotización"], ["Plomería de Emergencia", "Llamar ahora"]],
    },
    about: {
      label: "Sobre Marvin",
      title: "Un plomero local que trata a sus clientes como familia.",
      text: "Marvin Mendoza trae más de 20 años de experiencia práctica en plomería a cada llamada. Marvin Plumbing es un negocio familiar que atiende clientes residenciales y comerciales con precios honestos, comunicación constante y el compromiso de arreglar el problema bien desde la primera vez.",
      imageAlt: "Marvin Mendoza sonriendo durante una consulta con un cliente",
      points: ["Comunicación constante hasta terminar el trabajo", "Resuelve varios problemas en una sola visita", "Presupuesto claro antes de empezar"],
      promiseTitle: "La Promesa de Marvin Plumbing",
      promiseText: "Comunicación clara, precios por adelantado y trabajo cuidadoso desde la primera llamada hasta la limpieza final.",
      yearsLabel: "Años",
      emergencyLabel: "Emergencia",
    },
    gallery: {
      label: "Prueba visual",
      title: "Vea la Diferencia",
      text: "Fotos reales de proyectos de Marvin Plumbing. Las imágenes de antes y después se muestran completas — sin recortar, acercar ni poner texto encima.",
      jobs: [
        { title: "Reemplazo de calentador de agua", before: "waterHeaterBefore", after: "waterHeaterAfter", alt: "Antes y después de reemplazo de calentador de agua por Marvin Plumbing" },
        { title: "Mejora de seguridad en línea de gas", before: "gasMeterBefore", after: "gasMeterAfter", alt: "Antes y después de servicio de medidor y línea de gas por Marvin Plumbing" },
      ],
    },
    reviews: {
      label: "Confianza de clientes",
      title: "★★★★★ 4.8 en Google",
      text: "Comentarios reales de clientes que llamaron a Marvin Plumbing por fugas, calentadores de agua, baja presión y reparaciones urgentes.",
      link: "Ver Perfil de Google",
      cards: [
        { name: "Zoe Franklin", text: "Usé Marvin Plumbing para reparar una fuga debajo del fregadero de mi cocina y quedé muy contenta con el servicio. El técnico llegó a tiempo, explicó claramente el problema y terminó la reparación de manera eficiente." },
        { name: "Roman Bradford", text: "Marvin Plumbing reparó una tubería con fuga en nuestro cuarto de lavado. El técnico trabajó con cuidado, mantuvo el área limpia y verificó que todo funcionara bien antes de irse." },
        { name: "Colton Bradford", text: "Muy buena experiencia con Marvin Plumbing. Teníamos baja presión de agua en dos baños y encontraron el problema mucho más rápido de lo esperado. El servicio se sintió profesional y honesto." },
        { name: "Sullivan Wilder", text: "Marvin Plumbing nos ayudó con un problema de calentador de agua que necesitaba atención rápida. El plomero fue profesional, sabía lo que hacía y respondió todas nuestras preguntas." },
      ],
    },
    area: {
      label: "Área de servicio",
      title: "Sirviendo Oakland y el East Bay.",
      text: "Con base en Oakland, Marvin Plumbing ayuda a dueños de casa y negocios en todo el East Bay con servicio de plomería rápido y confiable.",
      cities: ["Oakland", "Berkeley", "Alameda", "Emeryville", "San Leandro", "Piedmont", "Áreas cercanas del East Bay"],
    },
    form: {
      label: "Ayuda hoy",
      title: "Pida un Presupuesto Gratis",
      text: "Cuéntenos qué está pasando. Su solicitud se guarda de forma confiable para que Marvin pueda responder.",
      name: "Nombre",
      namePlaceholder: "Su nombre",
      phone: "Teléfono",
      phonePlaceholder: "Mejor número para llamar",
      address: "Dirección o código postal",
      addressPlaceholder: "Oakland, 946__",
      problem: "Descripción del problema",
      problemPlaceholder: "Cuéntenos sobre la fuga, tapón, calentador, línea de gas o problema de plomería",
      submit: "Solicitar Presupuesto Gratis",
      submitting: "Enviando solicitud...",
      success: "Solicitud recibida. Marvin Plumbing le dará seguimiento pronto.",
      error: "Por favor complete todos los campos antes de enviar.",
      callHelp: "¿Necesita ayuda urgente? Llame ahora:",
    },
    footer: {
      areaTitle: "Área de Servicio",
      hours: "Horario: 7:00 AM–6:00 PM todos los días · servicio de emergencia 24/7",
      area: "Oakland, Berkeley, Alameda, Emeryville, San Leandro, Piedmont y áreas cercanas del East Bay",
    },
  },
};